import type { Feature } from '#/domain/customerAccess/Feature'
import type { CustomerAccessRepository } from '#/domain/customerAccess/CustomerAccessRepository'

export class GetAllFeaturesUseCase {
  constructor(private readonly repository: CustomerAccessRepository) {}

  execute(): Promise<Feature[]> {
    return this.repository.findAllFeatures()
  }
}
